import React, { useCallback, useEffect, useState } from 'react'
import { Box, Accordion, AccordionSummary, AccordionDetails, Theme, useMediaQuery, Grid, Button } from '@mui/material'
import { makeStyles } from '@mui/styles'
import moment from 'moment'
import * as ls from 'local-storage'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Timer } from './check-lists'
import { propsAction } from '../../../store/props'
import { getCheckList, showCheckList, startCheckList } from '../../../api'
import { modalsAction } from '../../../store/modals'
import { Requests } from '../../../types/default-types'
import { useReduxSelector } from '../../../hooks'

const Icon: React.FC<{ className: any; img: any }> = ({ className, img = [] }): JSX.Element => {
  return <img src={img.dropdown} alt="" className={className.icon} />
}

export const CheckListsTwoStage: React.FC<{
  img: any
  data: any
  stage: number
  className: any
  expanded: boolean
  onExpand: () => void
  openCheckList: () => void
}> = ({
  img = [],
  stage,
  data = [],
  className,
  expanded,
  onExpand = () => {},
  openCheckList = () => {},
}): JSX.Element => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const smDown = useMediaQuery(({ breakpoints: { down } }: Theme) => down(600))

  const { data: constants } = useReduxSelector((state) => state.constants)
  const { NOW = 0 } = constants || {}

  const [checkListsTwoSub, setCheckListsTwoSub] = useState<any>({})

  const [disabledBtn, setDisabledBtn] = useState<boolean>(false)

  const handleChangeExCheckListsTwo = () => {
    onExpand()
    setCheckListsTwoSub({})
  }

  const handleChangeExCheckListsTwoSub = (id: number, show: boolean) => {
    setCheckListsTwoSub({ ...checkListsTwoSub, [id]: show })
  }

  const loadCheckLists = useCallback((index: number, indexSub: number, status: string) => {
    if (status === 'NEW') {
      let checklist_all = {
        loaded: true,
        employee: undefined,
        checklist: undefined,
      }
      setDisabledBtn(true)
      openCheckList()
      dispatch(propsAction.setProps({ checklist_all }))

      getCheckList({ requestId: data[index].requests[indexSub].id })
        .then((res) => {
          if (res.status === 1) {
            checklist_all = {
              loaded: false,
              employee: { ...data[index].requests[indexSub], stage: 2 },
              checklist: { ...res.data.checklist },
            }
            dispatch(propsAction.setProps({ checklist_all }))
            ls.set('checklist', '?checklist')
            setDisabledBtn(false)
          } else {
            dispatch(
              modalsAction.alert({
                message: { error: [`${res.message}`] },
                onClose: () => {
                  setDisabledBtn(false)
                  navigate('../lk')
                },
              })
            )
          }
        })
        .catch(() => {
          dispatch(
            modalsAction.alert({
              message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
              onClose: () => {
                setDisabledBtn(false)
                navigate('../lk')
              },
            })
          )
        })
    } else if (status === 'ACTIVE') {
      setDisabledBtn(true)
      openCheckList()
      let checklist_all = {
        loaded: true,
        employee: undefined,
        checklist: undefined,
      }
      dispatch(propsAction.setProps({ checklist_all }))

      startCheckList({ requestId: data[index].requests[indexSub].id })
        .then((res) => {
          if (res.status === 1) {
            checklist_all = {
              loaded: false,
              employee: { ...data[index].requests[indexSub], stage: 2 },
              checklist: { ...res.data.checklist },
            }
            dispatch(propsAction.setProps({ checklist_all }))
            ls.set('checklist', '?checklist')
            setDisabledBtn(false)
          } else {
            dispatch(
              modalsAction.alert({
                message: res.message,
                onClose: () => {
                  setDisabledBtn(false)
                  navigate('../lk')
                },
              })
            )
          }
        })
        .catch(() => {
          dispatch(
            modalsAction.alert({
              message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
              onClose: () => {
                setDisabledBtn(false)
                navigate('../lk')
              },
            })
          )
        })
    } else if (status === 'FINISH') {
      setDisabledBtn(true)
      openCheckList()
      let checklist_all = {
        loaded: true,
        employee: undefined,
        checklist: undefined,
      }
      dispatch(propsAction.setProps({ checklist_all }))

      showCheckList({ checklistId: data[index].requests[indexSub].checklist.id })
        .then((res) => {
          if (res.status === 1) {
            checklist_all = {
              loaded: false,
              employee: { ...data[index].requests[indexSub], stage: 1 },
              checklist: { ...res.data.checklist },
            }
            dispatch(propsAction.setProps({ checklist_all }))
            ls.set('checklist', '?checklist')
            setDisabledBtn(false)
          } else {
            dispatch(
              modalsAction.alert({
                message: { error: [`${res.message}`] },
                onClose: () => {
                  setDisabledBtn(false)
                  navigate('../lk')
                },
              })
            )
          }
        })
        .catch(() => {
          dispatch(
            modalsAction.alert({
              message: { error: ['Сервер временно недоступен. Пожалуйста, попробуйте позже'] },
              onClose: () => {
                setDisabledBtn(false)
                navigate('../lk')
              },
            })
          )
        })
    }
  }, [])

  return (
    <Box className={classes.checkListsTwo}>
      <Accordion square={false} id="checkListsTwo" expanded={expanded} onChange={handleChangeExCheckListsTwo}>
        <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
          Чек-листы участников {stage === 2 && 'второго этапа'}
          {stage === 3 && 'третьего этапа'}
          {stage === 4 && 'финала Кубка IRB'}
        </AccordionSummary>
        <AccordionDetails>
          <Box className={className.contentAccordionDetails}>
            <Box mt="3px" mb={1}>
              {data.map((item: any, index: number) => {
                return (
                  <Box key={`checklists_request_two_level${index}`} className={className.subGroup}>
                    <Accordion
                      square={false}
                      key={`sub_group${index}`}
                      expanded={checkListsTwoSub[`${item.id}`]}
                      onChange={() => handleChangeExCheckListsTwoSub(item.id, !checkListsTwoSub[`${item.id}`])}
                    >
                      <AccordionSummary expandIcon={<Icon className={className} img={img} />}>
                        {item?.subdivision?.name ||
                          `${item?.user?.lastName} ${item?.user?.firstName} ${item?.user?.middleName || ''}`}
                      </AccordionSummary>
                      <AccordionDetails>
                        <Box className={className.subGroupAccordionDetailsBox}>
                          {item.requests.map((itemSub: Requests, indexSub: number) => {
                            return (
                              <Box key={index} mt={1} className={classes.checkListsItem}>
                                <Grid
                                  container
                                  wrap={smDown ? 'wrap' : 'nowrap'}
                                  justifyContent={smDown ? 'flex-start' : 'space-between'}
                                  alignItems="center"
                                  spacing={1}
                                >
                                  <Grid item xs={12} sm={6} md={5}>
                                    <Box className={classes.employeesName}>
                                      {itemSub.command.name
                                        ? itemSub.command.name
                                        : `${itemSub.command.users[0].lastName} ` +
                                          `${itemSub.command.users[0].firstName} ` +
                                          `${itemSub.command.users[0].middleName || ''}`}
                                    </Box>
                                    <Box className={classes.employeesNomination}>«{itemSub.nomination?.name}»</Box>
                                  </Grid>
                                  <Grid item xs="auto">
                                    <Button
                                      variant="contained"
                                      color="secondary"
                                      className={classes.btn}
                                      disabled={disabledBtn || itemSub.status === 'REJECT'}
                                      onClick={() => {
                                        loadCheckLists(index, indexSub, itemSub.checklist?.status || 'NEW')
                                      }}
                                    >
                                      Чек-лист
                                    </Button>
                                  </Grid>
                                  <Grid item xs="auto">
                                    <Box className={classes.checkListsTime}>
                                      {itemSub.checklist?.status === 'ACTIVE' &&
                                        itemSub.checklist?.endDatetime &&
                                        moment(NOW).isBefore(moment(itemSub.checklist?.endDatetime).valueOf()) && (
                                          <Timer timeEnd={moment(itemSub.checklist.endDatetime).valueOf()} />
                                        )}
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Box>
                            )
                          })}
                        </Box>
                      </AccordionDetails>
                    </Accordion>
                  </Box>
                )
              })}
            </Box>
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  checkListsTwo: {},
  checkListsItem: {
    marginBottom: 15,
  },
  employeesName: {
    fontSize: 16,
    fontWeight: 500,
    marginBottom: 3,
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  employeesNomination: {
    fontSize: 16,
    fontWeight: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 15,
    },
    [down('sm')]: {
      fontSize: 14,
      marginBottom: 2,
    },
  },
  checkListsTime: {
    fontSize: 17,
    fontWeight: 600,
    color: '#6C6C6C',
    width: 120,
    textAlign: 'center',
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  btn: {
    fontSize: '16px!important',
    padding: '10px 35px!important',
    minHeight: '30px!important',
    minWidth: '100px!important',
    [down('md')]: {
      fontSize: '15px!important',
      padding: '10px 25px!important',
      minHeight: '30px!important',
    },
    [down('sm')]: {
      fontSize: '12px!important',
      padding: '10px 25px!important',
      minHeight: '25px!important',
      minWidth: '10px!important',
    },
  },
  icon: {},
}))
